export default __webpack_public_path__ + "static/media/Img_program.c064cdd1.jpg";